import {Component, OnInit, Optional} from '@angular/core';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {AlertService} from 'src/app/services/alert/alert.service';
import {BsModalRef} from 'ngx-bootstrap/modal';
import { ColDef, ColGroupDef, GridOptions } from 'ag-grid-community';
import 'ag-grid-enterprise';
import { HhgCarrierRateFilingService } from '../hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';

@Component({
    selector: 'tsp-status-portal',
    templateUrl: './tsp-status-portal.component.html',
    styleUrls: ['./tsp-status-portal.component.css'],
    standalone: false
})

export class TspStatusPortalComponent implements OnInit {
  rawData: any;
  carrierRateProcurementGridOptions: GridOptions = this.initializeGridOptions();
  carrerColumnDefs: any;
  parsingRawDate: any;
  closeBtnName: string;
  constructor(private alertService: AlertService,
              private loader: LoadingService,
              private hhgCarrierRateFilingService : HhgCarrierRateFilingService,
              @Optional() private bsModalRef?: BsModalRef){}
              
  ngOnInit(): void {
    this.loader.show()
    this.loadRawData();
    this.carrierRateProcurementGridOptions = this.initializeGridOptions();
    this.carrerColumnDefs = this.carrierRateProcurementColumnDefs();
  }

  carrierRateProcurementColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
      {
        headerName: 'SCAC',
        field: 'scac',
        filter: 'agTextColumnFilter'
      },

      {
        headerName: 'Domestic HHG',
        filter: 'agTextColumnFilter',
        field: 'inActiveMessageDMHHG'
      },
      {
        headerName: 'International HHG',
        filter: 'agTextColumnFilter',
        field: 'inActiveMessageINTHHG'
      },
      {
        headerName: 'Extended Storage',
        filter: 'agTextColumnFilter',
        field: 'inActiveMessageEXTHHG'
      }
    ];
  }

  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      domLayout: 'autoHeight',
      rowData: this.rawData,
      defaultCsvExportParams: {
        fileName: 'HHG_TSPs_In_Temp_NonUse_Report'
      },
      defaultExcelExportParams: {
        fileName: 'HHG_TSPs_In_Temp_NonUse_Report'
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
    };
  }

  loadRawData(){
    this.hhgCarrierRateFilingService.getInactiveHHGTSP().subscribe(inactiveHHGTSP => {
      this.rawData = inactiveHHGTSP.filter((carrierAppEntity) => {
        return (carrierAppEntity.inActiveMessageDMHHG.includes('Temporary') ||
                carrierAppEntity.inActiveMessageEXTHHG.includes('Temporary') ||
                carrierAppEntity.inActiveMessageINTHHG.includes('Temporary'));
      });
      this.rawData.sort((a, b) => {
        return (a.scac > b.scac) ? 1 : -1;
      });
      this.loader.hide();
    }, () => {
      this.loader.hide();
      this.alertService.error('There was an error retrieving HHG Rate Types List');
    });
  }

  close(){
    if (this.closeBtnName && this.closeBtnName.length > 0) this.bsModalRef.hide();
  }
}